import style from  "./SuccessMod.module.css";
import { useEffect } from 'react'
import image from "../../data/img/success.png"

export default function SuccessMod({ idp }) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const sessionId = urlParams.get("session_id")
  const QTY = urlParams.get("QS")

  const url = "https://www.wegest.it/stripe_sms/get_transation.php"

  const paramsPost = "I=" + idp + "&Q=" + QTY + "&S=" + sessionId;

  useEffect(() => {

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: paramsPost,
    })

      .then(response => response.json())
      .then(result => {
        console.log('Success:', result);
      })
      .catch(error => {
        console.error('Error:', error);
      });

  }, [paramsPost]);


  const homepage = `${window.location.origin}/?IDP=${idp}`

  return (
    <div className={style.wrapperMain} >
      <div>
        <h1 >Pagamento eseguito </h1>
        <p>Il tuo credito SMS è stato caricato sul tuo account WeGest</p>
        <a href={homepage}><button className={style.Btn}>Torna agli acquisti</button></a>
      </div>
      <div>
        <img className={style.img} alt="ok img" src={image}  />
      </div>
    </div>
  )
}